import * as React from 'react';

interface IUseNoBodyScroll {
  noScroll: boolean;
}

export const useNoBodyScroll = (args: IUseNoBodyScroll) => {
  const [body, setBody] = React.useState<any>();

  React.useEffect(() => {
    const bodyElement = document.getElementsByTagName('body')[0];
    if (bodyElement) {
      setBody(bodyElement);
    }
  }, []);

  React.useEffect(() => {
    if (body && args.noScroll) {
      body?.classList?.add('fixed');
    } else if (body?.classList?.contains('fixed')) {
      body?.classList?.remove('fixed');
    }
  }, [args.noScroll]);
};
